import { BuilderDetails } from "../mockData/mockBuilderDetails";
import locationIcon from "@/assets/icons/location.svg";
import callIcon from "@/assets/icons/call-green.svg";
import mailIcon from "@/assets/icons/email-green.svg";
import webIcon from "@/assets/icons/website-green.svg";

interface ProjectCardProps {
  project: BuilderDetails;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
  return (
    <div
      key={project.id}
      className="bg-white rounded-lg shadow-md overflow-hidden"
    >
      {/* Project image with type badge */}
      <div className="relative">
        <img
          src={project.projectImages[0].url}
          alt={project.projectImages[0].description}
          className="w-full h-44 object-cover"
        />
        <div className="absolute bottom-4 left-4 bg-[#fafafa] p-2 rounded-lg text-xs font-medium">
          {project.jobType}
        </div>
      </div>

      {/* Project details */}
      <div className="p-3">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-base font-semibold">{project.builderName}</h2>
          <span className="text-[#828282] text-base font-medium">
            {project.completedYear}
          </span>
        </div>

        <div className="flex flex-col gap-2 mb-4">
          <div className="flex items-center gap-1">
            <img src={locationIcon} alt="location icon" />
            <span className="text-sm font-normal">{project.city}</span>
          </div>
          <span className="text-[#828282] text-sm font-normal">
            {project.projectAddress}
          </span>
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-1">
            <img src={callIcon} alt="call icons" />
            <span className="text-sm text-[#828282] font-normal">
              {project.builderPhone}
            </span>
          </div>

          <div className="flex items-center gap-1">
            <img src={mailIcon} alt="mail icon" />
            <span className="text-sm text-[#828282] font-normal">
              {project.builderEmail}
            </span>
          </div>

          <div className="flex items-center gap-1">
            <img src={webIcon} alt="web icon" />
            <span className="text-sm text-[#828282] font-normal">
              {project.builderWebsite}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
